module.exports = __webpack_public_path__ + "static/media/munich.5cd89c60.jpeg";